import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateAppSettings } from '../../redux/actions/app-settings';
import * as viewModeSelectors from '../../selectors/view-mode';

import WixEvents from '../../constants/wix-sdk';
import {
  withPubSubEvents,
  consumePubSubEvent,
} from '../../containers/pub-sub-events';
import { getChannelLayout } from '../../selectors/app-settings';

const mapStateToProps = (state) => ({
  appSettings: state.appSettings,
  channelLayout: getChannelLayout(state),
  isSiteMode: viewModeSelectors.isSiteMode(state),
});

const mapDispatchToProps = {
  updateAppSettings,
};

export const AppSettingsObserver = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withPubSubEvents(
    class AppSettingsObserver extends React.Component {
      static propTypes = {
        children: PropTypes.func,
        appSettings: PropTypes.object,
        isSiteMode: PropTypes.bool.isRequired,
        updateAppSettings: PropTypes.func.isRequired,
      };

      handleEditModeChange = _.debounce(({ editMode }) => {
        this.props.updateAppSettings({ editMode });
      }, 100);

      handleStylesChange = _.debounce((styleParams) => {
        const { isSiteMode } = this.props;

        if (isSiteMode) {
          return;
        }

        if (this.props.channelLayout !== styleParams.numbers.channelLayout) {
          location.reload();
        } else {
          this.props.updateAppSettings(styleParams);
        }
      }, 100);

      componentDidUpdate(prevProps) {
        consumePubSubEvent(
          WixEvents.STYLE_PARAMS_CHANGE,
          this.handleStylesChange,
          {
            prevProps,
            nextProps: this.props,
          },
        );
        consumePubSubEvent(
          WixEvents.EDIT_MODE_CHANGE,
          this.handleEditModeChange,
          {
            prevProps,
            nextProps: this.props,
          },
        );
      }

      render() {
        const { children, appSettings } = this.props;

        if (children) {
          return children(appSettings);
        }

        return null;
      }
    },
  ),
);
